import { useRequest } from '@mgm/common/lib';
import { TAxiosError } from '@mgm/common/types';
import { CONTROLLERS } from '../utils/enums';
import { TUpdateSettingsReq } from '../types/requests';
import { TUpdateManagerPermissionsReq } from '../types/responses';
import { BASE_URL } from '../../config';
import { getIdToken } from '../utils/helpers';

export function SettingsController() {
  const {
    axiosRequest,
    initRequestOptions,
  } = useRequest(BASE_URL);

  const controllerName = CONTROLLERS.SETTINGS;

  const getSettings = <T>(data: { shopName: string }): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/get`, options);
  };
  const updateSettings = <T>(data: TUpdateSettingsReq): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/update_settings`, options);
  };

  const updateManagerPermissions = <T>(data: TUpdateManagerPermissionsReq): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/update_manager`, options);
  };

  const updateEmployeePermissions = <T>(data: TUpdateManagerPermissionsReq): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/update_employee`, options);
  };

  return {
    updateSettings,
    getSettings,
    updateManagerPermissions,
    updateEmployeePermissions,
  };
}
